import React, { FC } from 'react';
import { BotaoProps, Botao, BotaoFlat } from './Botao';
import { useFormikContext } from 'formik';



export const BotaoSalvar: FC<BotaoProps> = (props) => {
  const { isSubmitting } = useFormikContext();

  return <Botao
    type="submit"
    isLoading={isSubmitting}
    textoOnLoading="Salvando"
    {...props as any}>{props.children ?? 'Salvar'}</Botao>
};

export const BotaoCancelar: FC<BotaoProps> = (props) => {
  const { isSubmitting } = useFormikContext();

  return <BotaoFlat
    disabled={isSubmitting}
    tipo="cancel"
    {...props as any}>{props.children ?? 'Cancelar'}</BotaoFlat>
};

interface BotaoLimparProps {
  onClick?: () => void;
}

export const BotaoLimpar: FC<BotaoLimparProps> = ({onClick, children}) => {
  const { resetForm } = useFormikContext();
  const limpar = async () => {
    await resetForm();
    
    if (onClick) {
      onClick()
    }
  }

  return <BotaoFlat onClick={limpar} type="reset" tipo="cancel">{children ?? 'Limpar'}</BotaoFlat>
}